import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DataTable } from "../../components/data/DataTable";
import { listReceipts, listIssues, listTransfers } from "../../api/warehouse";
import { TransferActions } from "./TransferActions";
import { localName } from "../../lib/localName";

const STATE_COLORS = { pending_source: "sky", in_transit: "amber",
                        posted: "emerald", rejected: "rose" };

// تبويبات مستندات (وصولات · صرف · مناقلات) — أزرار المناقلات في مكوّن TransferActions.
export const WhDocsTab = ({ branchId, kind }) => {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);

  const load = () => {
    const fn = { receipts: listReceipts, issues: listIssues, transfers: listTransfers }[kind];
    fn(branchId || undefined).then((d) => setRows(d.items || [])).catch(() => setRows([]));
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [branchId, kind]);

  const cols = {
    receipts: [
      { key: "number", label: t("warehouse.doc.number"),
        render: (r) => <span className="num font-mono font-bold text-primary">
          {r.number || t("warehouse.states.draft")}</span> },
      { key: "ref", label: t("warehouse.doc.reference"),
        render: (r) => <span className="num font-mono text-xs text-amber-700">
          {r.purchase_order_number || r.ref_number || "—"}</span> },
      { key: "date", label: t("warehouse.doc.date"), render: (r) => <span className="num font-mono">{r.date}</span> },
      { key: "supplier", label: t("warehouse.doc.supplier"),
        render: (r) => <span className="text-xs">{localName(r.supplier)}</span> },
      { key: "state", label: t("warehouse.doc.state"),
        render: (r) => <span className="text-[11px] font-bold">{t(`warehouse.states.${r.state}`, r.state)}</span> },
    ],
    issues: [
      { key: "number", label: t("warehouse.doc.number"),
        render: (r) => <span className="num font-mono font-bold text-rose-600">{r.number}</span> },
      { key: "date", label: t("warehouse.doc.date"), render: (r) => <span className="num font-mono">{r.date}</span> },
      { key: "to", label: t("warehouse.doc.issuedTo"),
        render: (r) => <span className="text-xs">{r.issued_to || "—"}</span> },
      { key: "lines", label: t("warehouse.doc.lines"),
        render: (r) => <span className="num font-mono">{(r.lines || []).length}</span> },
    ],
    transfers: [
      { key: "number", label: t("warehouse.doc.number"),
        render: (r) => <span className="num font-mono font-bold text-violet-600">{r.number}</span> },
      { key: "route", label: t("warehouse.doc.route"),
        render: (r) => <span className="text-[11px]">{localName(r.from_wh)} → {localName(r.to_wh)}</span> },
      { key: "state", label: t("warehouse.doc.state"),
        render: (r) => <span className={`rounded-full bg-${STATE_COLORS[r.state] || "slate"}-500/15 px-2 py-0.5 text-[10px] font-bold text-${STATE_COLORS[r.state] || "slate"}-700`}>
          {t(`warehouse.tr.states.${r.state}`, r.state)}</span> },
      { key: "act", label: "",
        render: (r) => <TransferActions row={r} onDone={load} /> },
    ],
  };

  return <DataTable testid={`doc-${kind}`} columns={cols[kind]} rows={rows}
                    rowKey={(r) => r.id || r.issue_id || r.transfer_id}
                    empty={t(`warehouse.doc.empty.${kind}`)} />;
};
